import React, { Fragment } from "react";
import { matchPath } from 'react-router-dom';
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS,ASSETS } from "../utils/init";


import { Link, withRouter, } from "react-router-dom";
import btcLogo from "../assets/images/currency/BTC.svg";
import { RangeDatePicker } from "react-google-flight-datepicker";
import Dashboard from "../pages/Dashboard";
import BtcLogo from "../assets/images/currency/BTC.svg";
import EthLogo from "../assets/images/currency/ETH.svg";
import LtcLogo from "../assets/images/currency/LTC.svg";
import BchLogo from "../assets/images/currency/BCH.svg";
import { FetchMerchantStatus, GetAllTransactions } from '../utils/service';
import { showToast,showHttpError } from '../utils/library';

class MerchantTransactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageNo: 1,
      noOfItemsPerPage: 10,
      assets: [],
      selectedAsset: {},
      startDate: '',
      endDate: '',
    };
    
  }
  handleOnDateChange = (param1, param2) => {
    console.log(param1, param2)
    let startDay = new Date(param1);
    let endDay = new Date(param2);
    let startTime = "00:00:00";
    let endTime = "23:59:00";
    startDay = startDay.getFullYear() + "-" + (startDay.getMonth() + 1) + "-" + startDay.getDate();
    startDay = startDay + " " + startTime;
    endDay = endDay.getFullYear() + "-" + (endDay.getMonth() + 1) + "-" + endDay.getDate();
    endDay = endDay + " " + endTime;
    this.setState({
        startDate: startDay,
        endDate: endDay,
        selectionRangeForDateRange: {
            startDate: startDay,
            endDate: endDay,
            key: 'selection',
        }
    })
}
  handleChangeRadioBtn = e => {
    const { name, value } = e.target;
   console.log(value)
    this.setState({
      name: value
     
    });
  };

  handleViewTransaction = (e) => {
    e.preventDefault();
   
        
     this.setState({showLoader : true})
     let payload = {
      account_type :'',
      currency_id : '',
      from_date : this.state.startDate,
      merchant_id : localStorage.getItem(SITENAMEALIAS + '_merchant_id'),
      no_of_items_per_page : this.state.noOfItemsPerPage,
      to_date :this.state.endDate,
     }
     GetAllTransactions(payload).then(function(res){
          this.setState({showLoader : false})
          var response = res.data[0];
        
       }.bind(this)).catch(function(err){
          this.setState({showLoader : false})
          showHttpError(err)
      }.bind(this))
  
}


componentWillMount() {

  /* fetching data from url parameters */
  const match = matchPath(this.props.history.location.pathname, {
      path: "/merchant-transactions/:param1",
      exact: true,
      strict: false
    })
  console.log('PARAMS : ',match.params)
  this.setState({
      secureToken : match.params.param1,
      
  })
}
  componentDidMount() {
    let assets = ASSETS
  }
 
  
  render() {
    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-3"></div>
                    <div className="row">
                    <h4 className="col-md-11"> Merchant Transactions</h4>
                    <div className="text-right">
                    <button onClick={() => this.props.history.goBack()} className="btn btn-warning btn-rounded">
                      <i className="mdi mdi-arrow-left-bold"></i>
                    </button>
                    </div >
                   </div>
                   
                    <hr></hr>

                    <div className="row">
                      <div className="col-md-10">
                        <div className="row mt-4">
                          <div className="col-md-6" >
                            <input type="radio" value="1" name="radio" id="radio_1" className="form-check-input"  defaultChecked onChange={this.handleChangeRadioBtn} style={{marginLeft:10}} />
                            <label style={{marginLeft:25}}> Balance account </label>
                          </div>
                          <div className="col-md-6">
                            <input type="radio" value="2" name="radio" id="radio_2" className="form-check-input" onChange={this.handleChangeRadioBtn}/>
                            <label>  Rolling Reserve account </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                     
                      </div>
                    </div>
                    <div className="row mb-3"></div>
                    <div className="row">
                      <div className="col-md-6">
                        <RangeDatePicker
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          minDate={new Date(1900, 0, 1)}
                          maxDate={new Date(2100, 0, 1)}
                          onChange={(startDate, endDate) => this.handleOnDateChange(startDate, endDate)}
                          dateFormat="MM/DD/YYYY"
                          monthFormat="MMM YYYY"
                          startDatePlaceholder="Start Date"
                          endDatePlaceholder="End Date"
                          disabled={false}
                          className=""
                          startWeekDay="monday"
                        />
                      </div>
                      <div className="col-md-2">
                        <button type="button" className="btn btn-primary " style={{marginTop: 15, marginLeft:100}} onClick={(event) => {this.handleViewTransaction(event)}}>
                          view
                        </button>
                      </div>
                    
                    <div className="col-md-2">
                      <button type="button" className="btn btn-primary "style={{marginTop: 15}}>
                        DOWNLOAD (.CSV)
                      </button>
                    </div>
                    </div>
                    <br></br>
                    <hr></hr>

                    <div className="table-responsive">
                      <h3>BTC Transactions :</h3>
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Date & Time</th>
                            <th>Description</th>
                            <th>Credits</th>
                            <th>Debits </th>
                            <th>Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                             
                            </td>
                            <td>
                            
                            </td>
                            <td>
                              
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }

  componentDidMount() {}
}

export default withRouter(MerchantTransactions);
